module.exports = __webpack_public_path__ + "public/media/ALDORA.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/ALDORA.png
// module id = ./images/partners/ALDORA.png
// module chunks = 0